const $$splitComponentImporter = () => import('/home/runner/work/zngly-corporate/zngly-corporate/wp-content/themes/zngly-corporate/frontend/src/routes/test/media/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { MediaCatalogQuery, type Media_Catalog_Query } from '@/graphql/queries/Media.query';
import { RelayEnvironment } from '@/graphql/relay-env';
import { createFileRoute } from '@tanstack/react-router';
import { loadQuery } from 'react-relay';
export const Route = createFileRoute('/test/media/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr),
  loader: () => {
    return loadQuery<Media_Catalog_Query>(RelayEnvironment, MediaCatalogQuery, {});
  },
  pendingComponent: () => <div>Loading...</div>,
  wrapInSuspense: true
});